import { useMutation } from '@tanstack/react-query';

import { updateTelemetryEvent } from '../api/feedback.api';

interface UpdateTelemetryEventParams {
    id: number;
    est: number | null;
    event: number | null;
}

export const useUpdateTelemetryEvent = () => {
    return useMutation({
        mutationFn: ({ id, est, event }: UpdateTelemetryEventParams) =>
            updateTelemetryEvent(id, est, event),
    });
};
